import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskLines, Reveal } from "@/components/Motion";
import { imgPos } from "@/lib/api";
import { COLLECTION } from "@/data/site";

const Tile = ({ c, i }) => (
  <Reveal delay={i * 0.08} className={`h-[400px] md:h-[360px] lg:h-auto ${c.area}`}>
    <Link to={`/shop/${c.slug}`} data-testid={`collection-tile-${c.slug}`} className="group relative block h-full overflow-hidden bg-cocoa">
      <img src={c.img} alt={c.name} className={`absolute inset-0 w-full h-full object-cover ${imgPos(c.img)} transition-transform duration-[1.6s] ease-[cubic-bezier(.22,1,.36,1)] group-hover:scale-[1.03]`} />
      <div className="absolute inset-0 bg-gradient-to-t from-espresso/80 via-espresso/10 to-transparent" />
      <div className="absolute left-6 right-6 bottom-6 flex flex-col items-start gap-4 text-cream">
        <div>
          <p className="text-[11px] tracking-[0.24em] uppercase text-[#E9DED2]">{String(i + 1).padStart(2, "0")} — {c.note}</p>
          <h3 className="font-display text-4xl md:text-5xl mt-2 leading-none">{c.name}</h3>
        </div>
        <span className="shrink-0 flex items-center gap-2 text-[11px] uppercase tracking-[0.22em]">
          {c.price}
          <ArrowUpRight className="w-4 h-4 transition-transform duration-500 group-hover:rotate-45" strokeWidth={1.4} />
        </span>
      </div>
    </Link>
  </Reveal>
);

export const Featured = () => (
  <section data-testid="featured-section" className="mx-auto max-w-[1440px] px-5 md:px-10 py-28 md:py-44">
    <div className="grid md:grid-cols-12 gap-6 items-end mb-14 md:mb-20">
      <div className="md:col-span-7">
        <p className="eyebrow mb-6">The Collection</p>
        <MaskLines lines={["Small batch.", <span className="italic text-mocha">Beautifully finished.</span>]} className="font-display font-light text-5xl sm:text-6xl lg:text-7xl leading-[0.95]" />
      </div>
      <Reveal className="md:col-span-4 md:col-start-9">
        <p className="text-mocha leading-relaxed">A focused menu of cookies, cupcakes and signature boxes, each baked to order and made to be shared, gifted or savoured slowly.</p>
      </Reveal>
    </div>
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4 lg:grid-rows-[340px_340px] lg:auto-rows-fr">
      {COLLECTION.map((c, i) => <Tile key={c.slug} c={c} i={i} />)}
    </div>
  </section>
);
